import Main  from './Main.jsx';

export default function Book( {cards}){

  return(<div>
      <Main cards={cards}></Main>
    </div>);
}
